(function () {
  function readSession(key) {
    try {
      return JSON.parse(sessionStorage.getItem(key));
    } catch (e) {
      return null;
    }
  }

  function writeSession(key, value) {
    try {
      if (value === null) sessionStorage.removeItem(key);
      else sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }

  function productPath(pathname) {
    return pathname.replace(/\/collections\/[^/]+(?=\/products\/)/, '').replace(/\/$/, '');
  }

  function rememberCollection() {
    var title = document.querySelector('[data-collection-title]')?.textContent || document.title;
    writeSession('lastCollection', { title: title, url: location.pathname + location.search });
    writeSession('lastSearch', null);
  }

  function rememberSearchProduct(event) {
    if (event.defaultPrevented || (event.type === 'auxclick' ? event.button !== 1 : event.button !== 0)) return;
    var link = event.target.closest('a[href]');
    if (!link) return;
    var url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !url.pathname.includes('/products/')) return;

    var q = link.getAttribute('data-bc-search-term');
    if (q === null && tpl.indexOf('collection') > -1) {
      rememberCollection();
      return;
    }
    if (q === null && tpl.indexOf('search') > -1) q = new URLSearchParams(location.search).get('q');
    if (!q || !q.trim()) return;

    writeSession('lastSearch', { q: q, productPath: productPath(url.pathname) });
  }

  function renderSearchBreadcrumb(container, search) {
    var arrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    arrow.setAttribute('width', '16');
    arrow.setAttribute('height', '16');
    arrow.setAttribute('viewBox', '0 0 24 24');
    arrow.setAttribute('fill', 'none');
    arrow.setAttribute('class', 'breadcrumb__arrow breadcrumb__arrow--search');
    arrow.setAttribute('aria-hidden', 'true');

    var arrowPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    arrowPath.setAttribute(
      'd',
      'M8.67876 14.0741L14.3084 19.7037C14.7034 20.0988 15.296 20.0988 15.6911 19.7037L17.0738 18.321C17.4689 17.9259 17.4689 17.3333 17.0738 16.9383L12.2343 12L17.0738 7.06173C17.4689 6.66667 17.4689 6.07407 17.0738 5.67901L15.6911 4.2963C15.296 3.90123 14.7035 3.90123 14.3084 4.2963L7.29604 11.3086C6.90098 11.7037 6.90098 12.2963 7.29604 12.6914L8.67876 14.0741Z'
    );
    arrowPath.setAttribute('fill', 'black');
    arrow.appendChild(arrowPath);

    var results = document.createElement('a');
    results.href = container.getAttribute('data-bc-search-url') + '?q=' + encodeURIComponent(search.q);
    results.textContent = 'Resultados para "' + search.q + '"';

    container.replaceChildren(arrow, results);
    container.hidden = false;
    var nav = container.closest('.breadcrumb');
    nav.classList.remove('hidden');
    nav.querySelectorAll('[data-bc-server]').forEach(function (server) {
      server.remove();
    });
  }

  function updateSearchBreadcrumbs(search) {
    writeSession('lastSearch', { q: search.q, productPath: productPath(location.pathname) });
    document.querySelectorAll('[data-bc-dynamic][data-bc-product-title]').forEach(function (container) {
      renderSearchBreadcrumb(container, search);
    });
  }

  var tpl = document.documentElement.getAttribute('data-template') || '';
  document.addEventListener('click', rememberSearchProduct);
  document.addEventListener('auxclick', rememberSearchProduct);
  window.addEventListener('pageshow', function () {
    if (tpl.indexOf('collection') > -1) rememberCollection();
  });

  try {
    if (tpl.indexOf('search') > -1) {
      var params = new URLSearchParams(location.search);
      var q = params.get('q');
      if (q) {
        writeSession('lastSearch', { q: q });
      } else {
        writeSession('lastSearch', null);
      }
    }
    if (tpl.indexOf('collection') > -1) {
      rememberCollection();
    }
    if (tpl.indexOf('product') > -1) {
      var dyn = document.querySelector('[data-bc-dynamic]');
      var mobileBreadcrumb = document.querySelector('.breadcrumb--mobile [data-bc-dynamic]');
      if (!dyn) return;

      var s = readSession('lastSearch');
      var searchOrigin = null;
      if (s && typeof s.q === 'string' && s.q.trim() && s.productPath === productPath(location.pathname)) {
        searchOrigin = s;
      }
      if (document.referrer) {
        var referrer = new URL(document.referrer);
        var searchUrl = dyn.getAttribute('data-bc-search-url');
        if (referrer.origin === location.origin && referrer.pathname === searchUrl && referrer.searchParams.get('q')) {
          searchOrigin = { q: referrer.searchParams.get('q') };
        }
      }
      var queryTerm = new URLSearchParams(location.search).get('breadcrumb_search');
      if (queryTerm && queryTerm.trim()) {
        searchOrigin = { q: queryTerm };
      }
      if (searchOrigin) {
        updateSearchBreadcrumbs(searchOrigin);
        document.addEventListener('product-info:loaded', function (event) {
          if (event.target.matches('product-info[id^="MainProduct-"]')) {
            updateSearchBreadcrumbs(searchOrigin);
          }
        });
        return;
      }

      var menuScript = document.getElementById('breadcrumb-menu-json');
      if (!menuScript) return;
      var menu = JSON.parse(menuScript.textContent || '{}');

      var lastCollection = readSession('lastCollection');
      var collUrl = null;
      if (lastCollection) {
        try {
          collUrl = lastCollection.url.split('?')[0];
        } catch (e) {}
      }
      if (!collUrl) {
        dyn.remove();
        return;
      }

      function walk(links, trail) {
        for (var i = 0; i < links.length; i++) {
          var l = links[i];
          var norm = (l.url || '').replace(location.origin, '');
          var newTrail = trail.concat([{ title: l.title, url: l.url }]);
          if (norm === collUrl) return newTrail;
          if (l.links && l.links.length) {
            var found = walk(l.links, newTrail);
            if (found) return found;
          }
        }
        return null;
      }

      var trail = walk(menu.links || [], []);
      if (trail && trail.length) {
        var html = '';

        // Función para detectar si es mobile
        function isMobile() {
          return window.innerWidth <= 768;
        }

        // Función para crear el ícono SVG de flecha izquierda
        function createArrowIcon() {
          return (
            '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" class="breadcrumb__arrow">' +
            '<path d="M8.67876 14.0741L14.3084 19.7037C14.7034 20.0988 15.296 20.0988 15.6911 19.7037L17.0738 18.321C17.4689 17.9259 17.4689 17.3333 17.0738 16.9383L12.2343 12L17.0738 7.06173C17.4689 6.66667 17.4689 6.07407 17.0738 5.67901L15.6911 4.2963C15.296 3.90123 14.7035 3.90123 14.3084 4.2963L7.29604 11.3086C6.90098 11.7037 6.90098 12.2963 7.29604 12.6914L8.67876 14.0741Z" fill="black"/>' +
            '</svg>'
          );
        }

        if (isMobile()) {
          if (trail.length >= 1) {
            var lastVisitedCategory = trail[trail.length - 1];

            html =
              createArrowIcon() +
              '<a href="' +
              lastVisitedCategory.url +
              '" class="breadcrumb__mobile-link breadcrumb__current" aria-current="page">' +
              lastVisitedCategory.title +
              '</a>';
          } else {
            html = '';
          }
        } else {
          if (trail.length === 1) {
            html =
              createArrowIcon() +
              '<a href="' +
              trail[0].url +
              '" class="breadcrumb__mobile-link breadcrumb__current" aria-current="page">' +
              trail[0].title +
              '</a>';
          } else {
            for (var j = 0; j < trail.length; j++) {
              if (j < trail.length - 1) {
                if (j > 0) html += '<span class="breadcrumb__sep" aria-hidden="true">›</span>';
                html += '<a href="' + trail[j].url + '">' + trail[j].title + '</a>';
              } else {
                if (j > 0) html += '<span class="breadcrumb__sep" aria-hidden="true">›</span>';
                html +=
                  '<a class="breadcrumb__current" aria-current="page" href="' +
                  trail[j].url +
                  '">' +
                  trail[j].title +
                  '</a>';
              }
            }
          }
        }

        dyn.hidden = false;
        dyn.innerHTML = html;

        // También actualizar el breadcrumb mobile si existe
        if (mobileBreadcrumb) {
          mobileBreadcrumb.hidden = false;
          mobileBreadcrumb.innerHTML = html;
        }

        var serverSpan = document.querySelector('[data-bc-server]');
        if (serverSpan) serverSpan.remove();

        // También remover el serverSpan del breadcrumb mobile
        var mobileServerSpan = document.querySelector('.breadcrumb--mobile [data-bc-server]');
        if (mobileServerSpan) mobileServerSpan.remove();

        // Agregar listener para redimensionamiento de ventana
        var handleResize = function () {
          if (trail && trail.length) {
            var newHtml = '';
            if (isMobile()) {
              if (trail.length >= 1) {
                var lastVisitedCategory = trail[trail.length - 1];

                newHtml =
                  createArrowIcon() +
                  '<a href="' +
                  lastVisitedCategory.url +
                  '" class="breadcrumb__mobile-link breadcrumb__current" aria-current="page">' +
                  lastVisitedCategory.title +
                  '</a>';
              } else {
                newHtml = '';
              }
            } else {
              if (trail.length === 1) {
                // ✅ Cambio: el único item debe ser "current"
                newHtml =
                  createArrowIcon() +
                  '<a href="' +
                  trail[0].url +
                  '" class="breadcrumb__mobile-link breadcrumb__current" aria-current="page">' +
                  trail[0].title +
                  '</a>';
              } else {
                for (var j = 0; j < trail.length; j++) {
                  if (j < trail.length - 1) {
                    if (j > 0) newHtml += '<span class="breadcrumb__sep" aria-hidden="true">›</span>';
                    newHtml += '<a href="' + trail[j].url + '">' + trail[j].title + '</a>';
                  } else {
                    if (j > 0) newHtml += '<span class="breadcrumb__sep" aria-hidden="true">›</span>';
                    newHtml +=
                      '<a class="breadcrumb__current" aria-current="page" href="' +
                      trail[j].url +
                      '">' +
                      trail[j].title +
                      '</a>';
                  }
                }
              }
            }
            dyn.innerHTML = newHtml;

            // También actualizar el breadcrumb mobile
            if (mobileBreadcrumb) {
              mobileBreadcrumb.innerHTML = newHtml;
            }
          }
        };

        // Debounce para evitar demasiadas llamadas
        var resizeTimeout;
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(handleResize, 100);
        });
      } else {
        dyn.remove();
        // También remover el breadcrumb mobile si no hay trail
        if (mobileBreadcrumb) {
          mobileBreadcrumb.remove();
        }
      }
    }
  } catch (e) {
    console.error('Error en breadcrumbs.js:', e);
  }
})();
